export interface PublicShareAccessState {
  hasToken: boolean;
  hasInfo: boolean;
  isShareActive: boolean;
  requiresPassword: boolean;
  isPasswordVerified: boolean;
}

export function shouldEnablePublicProjectShareAccess({
  hasToken,
  hasInfo,
  isShareActive,
  requiresPassword,
  isPasswordVerified,
}: PublicShareAccessState): boolean {
  return hasToken && hasInfo && isShareActive && (!requiresPassword || isPasswordVerified);
}

export function isPublicSharedRequestUrl(url?: string): boolean {
  return Boolean(url?.startsWith('/public/shared/'));
}
